export const iconFontAwesomeFilesFileExport = (
	<i className="fa-solid fa-file-export"></i>
);
